import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает состояние просмотренных объявлений
 */
export const selectOffersFromHistoryStatus = ({ recommendedOffers: { offersFromHistory } }: IApplicationState) =>
  offersFromHistory.status;
